import React, { PureComponent } from 'react';
import { times, get } from 'lodash';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import SectionTitle from '@src/components/SectionTitle';
import { WORK_LOAD_PERIOD } from '@src/constants';
import './styles.scss';

export default class PartTimeHours extends PureComponent {
  static propTypes = {
    setWorkload: PropTypes.func.isRequired,
    workload: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = { workload: props.workload };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.workload !== this.state.workload) {
      this.setState({ workload: nextProps.workload });
    }
  }

  render() {
    const { workload } = this.state;

    return (
      <div className="create-funnel-working-hours">
        <SectionTitle subtitle="Average number of working hours per week." title="Working time" />

        <div className="working-hours-dropdown">
          <select
            onChange={e => this.props.setWorkload({ hours: Number(e.target.value), period: WORK_LOAD_PERIOD.WEEK })}
            value={!workload || (workload && workload.hours === 40) ? 0 : get(workload, 'hours', 1)}
          >
            {times(10, index => {
              if (index > 0) {
                index = index * 4;
              }

              if (index === 0) {
                return (
                  <option disabled key={index} selected value={index}>
                    Select
                  </option>
                );
              }

              return (
                <option key={index} value={index}>
                  {`${pluralize('hour', index, true)}`}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }
}
